import { Button } from "@/components/ui/button";
import { Undo2, X, Check } from "lucide-react";
import { fmtLen, pathLength } from "@/lib/network";
import { EndpointSearch } from "@/components/network/EndpointPicker";

export const draftPath = (d) => [
  ...(d.from ? [[d.from.latitude, d.from.longitude]] : []), ...d.points, ...(d.to ? [[d.to.latitude, d.to.longitude]] : []),
];

export function CableDrawBar({ draft, onUndo, onCancel, onDone, endpoints, onPickEndpoint }) {
  const step = !draft.from ? "Langkah 1: klik ODC/ODP/OTB sebagai titik awal kabel (perangkat di dalam SERVER/FDT: klik marker kontainernya atau cari di bawah)."
    : !draft.to ? "Langkah 2: klik peta untuk menambah titik belokan, lalu klik tujuan (ODP/OTB; ODC hanya dari OTB). Titik belokan bisa digeser."
      : "Rute lengkap. Geser titik belokan bila perlu, lalu klik Lanjut.";
  return (
    <div className="w-full rounded-lg border border-[#0055FF]/30 bg-white p-3 text-xs" data-testid="cable-draw-bar">
      <div className="mb-1 font-bold text-[#0055FF]">{draft.editing ? `Edit Rute ${draft.editing.kode}` : "Gambar Jalur Kabel"}</div>
      <p data-testid="cable-draw-step">{step}</p>
      <p className="mt-1 text-[#6B7280]" data-testid="cable-draw-info">
        {draft.from ? `${draft.from.kode}` : "—"} → {draft.to ? draft.to.kode : "…"} · {draft.points.length} belokan · ±{fmtLen(pathLength(draftPath(draft)))}
      </p>
      <div className="mt-2 flex flex-wrap gap-2">
        <Button size="sm" variant="outline" className="h-10" onClick={onUndo} disabled={!draft.from} data-testid="cable-draw-undo">
          <Undo2 className="mr-1 h-3.5 w-3.5" />Undo</Button>
        <Button size="sm" variant="outline" className="h-10" onClick={onCancel} data-testid="cable-draw-cancel">
          <X className="mr-1 h-3.5 w-3.5" />Batal</Button>
        <Button size="sm" className="h-10 bg-[#0055FF]" onClick={onDone} disabled={!draft.to} data-testid="cable-draw-done">
          <Check className="mr-1 h-3.5 w-3.5" />Lanjut</Button>
      </div>
      {endpoints && !draft.to && <EndpointSearch items={endpoints} onPick={onPickEndpoint} />}
    </div>
  );
}
